// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"8fa1ad0b","213":"3aa5cb70","239":"33fa1594","278":"a04f5aaf","453":"3d2446d5","455":"364ce369","807":"8b2292c5","855":"91c1bb5e"}[chunkId] + ".chunk.js";
};